/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-refresh/only-export-components */
import React from 'react'
import ReactDOM from 'react-dom/client'
import { lazy } from 'react'

const Components = lazy(() => import('./Components.tsx'))
const Menu = lazy(() => import('./menuComponent/Menu.tsx'))
const RichTextAccordion = lazy(
  () => import('./richTextAccordion/RichTextAccordion.tsx')
)
const DownloadAccordion = lazy(
  () => import('./downloadAccordion/DownloadAccordion.tsx')
)

const WhitePaperAccordion = lazy(
  () => import('./whitePaperAccordion/WhitePaperAccordion.tsx')
)

const RteAccordion = lazy(() => import('./rteAccordion/RteAccordion.tsx'))

const View360Stl = lazy(() => import('./view360Stl/View360Stl.tsx'))
const ThreeTilesOverview = lazy(
  () => import('./threeTilesOverview/ThreeTilesOverview.tsx')
)

const ContactOverview = lazy(
  () => import('./contactOverview/ContactOverview.tsx')
)
const ImageGallery = lazy(() => import('./imageGallery/ImageGallery.tsx'))
const VideoPlayer = lazy(() => import('./videoPlayer/VideoPlayer.tsx'))
const TabNavigation = lazy(() => import('./tabNavigation/TabNavigation.tsx'))
const ProductOverview = lazy(
  () => import('./productOverview/ProductOverview.tsx')
)
const ContentCardBlock = lazy(
  () => import('./contentCardBlock/ContentCardBlock.tsx')
)
const CasesOverview = lazy(() => import('./casesOverview/CasesOverview.tsx'))
const JobApplication = lazy(() => import('./jobApplication/JobApplication.tsx'))

const appRegistry: {
  [key: string]: React.LazyExoticComponent<
    ({ id, content }: { id: string; content: any }) => JSX.Element
  >
} = {
  Components,
  Menu,
  RichTextAccordion,
  DownloadAccordion,
  View360Stl,
  ThreeTilesOverview,
  ContactOverview,
  ImageGallery,
  VideoPlayer,
  TabNavigation,
  WhitePaperAccordion,
  RteAccordion,
  ProductOverview,
  CasesOverview,
  ContentCardBlock,
  JobApplication,
}

document.querySelectorAll<HTMLElement>('[data-module]').forEach((elm) => {
  const Module = appRegistry[elm.dataset.module!]
  const props = appRegistry[elm.dataset.props!]
  let content = null

  try {
    content = JSON.parse(elm.dataset.content || '{}')
  } catch {
    console.error(
      'JSON Error on ' + elm.dataset.module + ' module, module not rendered'
    )
  }

  if (Module) {
    ReactDOM.createRoot(elm!).render(
      <React.StrictMode>
        <Module id={elm.id} content={content} {...props} />
      </React.StrictMode>
    )
  } else {
    console.info(`Module ${elm.dataset.module} not found`)
  }
})
